import React, { createContext, useContext } from 'react';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';

export const FormSchemaContext = createContext<Yup.AnySchema | undefined>(undefined);

export function FormSchemaProvider({
  schema,
  children,
}: {
  schema?: Yup.AnySchema;
  children: React.ReactNode;
}): JSX.Element {
  return <FormSchemaContext.Provider value={schema}>{children}</FormSchemaContext.Provider>;
}

export function useFieldRequired(name: string): boolean {
  const schema = useContext(FormSchemaContext);
  const formik = useFormikContext<Record<string, unknown>>();
  const values = formik?.values ?? {};
  if (!schema || !name) return false;
  try {
    const fieldSchema = Yup.reach(schema, name) as Yup.AnySchema | undefined;
    if (!fieldSchema) return false;
    const desc = (fieldSchema as unknown as {
      describe: (options?: { value?: unknown; context?: unknown }) => {
        tests?: { name?: string }[];
        optional?: boolean;
      };
    }).describe({ value: values });
    if (Array.isArray(desc?.tests) && desc.tests.some((t) => t?.name === 'required')) {
      return true;
    }
    return desc?.optional === false;
  } catch {
    return false;
  }
}
